"use client";

import StyledIcon from "@litonarefin/components/StyledIcon";
import { cn } from "@litonarefin/utils";
import { getIcon } from "@litonarefin/utils/icons";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { getShareLinks } from "@litonarefin/utils/socialShare";

const SocialShareLeft = ({ title }) => {
  const [copiedText, setCopiedText] = useState({ copied: false });
  // const [showSocialShare, setShowSocialShare] = useState(false);

  const pathname = usePathname();

  const socialPath = `${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}${pathname}`;
  const shareLinks = getShareLinks(socialPath, title);

  useEffect(() => {
    let interval;
    if (copiedText?.copied === true) {
      interval = setInterval(() => {
        setCopiedText({ copied: false });
      }, 6000);
    }
    return () => clearInterval(interval);
  }, [copiedText]);

  // Scroll Parcentage
  // const scrollParcentage = () => {
  //   const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  //   const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  //   const scrolled = (winScroll / height) * 150;

  //   if (scrolled && scrolled > 10) {
  //     setShowSocialShare(true);
  //   } else {
  //     setShowSocialShare(false);
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", scrollParcentage);

  //   return () => window.removeEventListener("scroll", scrollParcentage);
  // }, []);

  // if (!showSocialShare) return null;

  return (
    <div className="jlt-flex jlt-flex-col">
      <div>
        <div className="jlt-ml-4">
          <div className="jlt-flex jlt-items-center jlt-gap-3">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={shareLinks.facebook}
              className="jlt-p-3 jlt-rounded-full jlt-bg-muted jlt-border jlt-border-border jlt-grayscale jlt-transition-all jlt-duration-150 hover:jlt-filter-none"
              aria-label="Share facebook"
            >
              {getIcon("facebook")}
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={shareLinks.twitter}
              className="jlt-p-3 jlt-rounded-full jlt-bg-muted jlt-border jlt-border-border jlt-grayscale jlt-transition-all jlt-duration-150 hover:jlt-filter-none"
              aria-label="Share twitter"
            >
              {getIcon("twitter")}
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={shareLinks.linkedin}
              className="jlt-p-3 jlt-rounded-full jlt-bg-muted jlt-border jlt-border-border jlt-grayscale jlt-transition-all jlt-duration-150 hover:jlt-filter-none"
              aria-label="Share linkedin"
            >
              {getIcon("linkedin")}
            </a>

            <CopyToClipboard
              text={`${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}${pathname}`}
              onCopy={() => setCopiedText({ copied: true })}
            >
              <button
                className={`jlt-p-3 jlt-rounded-full jlt-bg-muted jlt-border jlt-border-border jlt-grayscale jlt-transition-all jlt-duration-150 hover:jlt-filter-none${
                  copiedText?.copied ? " jlt-text-[#039855] jlt-font-bold" : " jlt-text-forground"
                }`}
                aria-label="Copy to post link"
                role="button"
              >
                {copiedText?.copied ? (
                  <>{getIcon("check")}</>
                ) : (
                  <StyledIcon type="stroke" styles={{ stroke: "#a3a3a3" }}>
                    {getIcon("copy")}
                  </StyledIcon>
                )}
              </button>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialShareLeft;
